import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9228a780")

_pushScopeId("data-v-9228a780")
const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = {
  key: 0,
  class: "text-14px"
}
const _hoisted_3 = {
  key: 1,
  class: "text-14px"
}
const _hoisted_4 = {
  class: "text-sm font-medium font-montserrat w-auto text-black-lp-200",
  style: {"max-width":"338px"}
}
const _hoisted_5 = { class: "mb-3 flex items-center justify-between gap-x-5" }
const _hoisted_6 = { class: "font-semibold text-14px text-black-lp-200 tracking-[-0.28px]" }
const _hoisted_7 = { class: "mb-3 flex flex-wrap gap-1 min-h-[60px]" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2 pt-2 border-t border-gray-lp-400"
}
const _hoisted_9 = {
  key: 1,
  class: "w-6 h-6"
}
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = {
  key: 3,
  class: "w-6 h-6"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_ctx.popoverData)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("span", null, [
          (_ctx.displayList.length > 0)
            ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.displayList[0]), 1))
            : (_openBlock(), _createBlock("span", _hoisted_3, "-")),
          (_ctx.popoverData.list.length > _ctx.popoverData.maxDisplay)
            ? (_openBlock(), _createBlock("button", {
                key: 2,
                class: "pl-1 cursor-pointer text-14px text-red-lp-100 underline font-semibold",
                tabindex: "0",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openOverlayPanel && _ctx.openOverlayPanel(...args)), ["stop"]))
              }, " Lihat " + _toDisplayString(_ctx.remainingCount) + " Lainnya ", 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_OverlayPanel, {
          ref: _ctx.opKey,
          appendTo: "body",
          class: "reason-popover"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("h3", _hoisted_6, _toDisplayString(_ctx.popoverData.title), 1),
                _createVNode("button", {
                  class: "cursor-pointer w-6 h-6 flex items-center justify-center",
                  "aria-hidden": "true",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeOverlayPanel && _ctx.closeOverlayPanel(...args)))
                }, [
                  _createVNode(_component_Icons, {
                    name: "close",
                    class: "w-4 h-4 text-gray-lp-600"
                  })
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paginatedList, (item, idx) => {
                  return (_openBlock(), _createBlock("span", {
                    key: idx,
                    class: "rounded-full bg-gray-lp-200 px-2 py-1 text-10px font-medium text-black-lp-300"
                  }, _toDisplayString(item), 1))
                }), 128))
              ]),
              (_ctx.totalPages > 1)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    (_ctx.currentPage > 1)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          class: "focus:outline-none p-1 hover:bg-gray-lp-200 rounded transition-colors",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
                        }, [
                          _createVNode("img", {
                            src: require('@/app/ui/assets/svg/chevron-prev.svg'),
                            alt: "Previous",
                            class: "h-4 w-4"
                          }, null, 8, ["src"])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_9)),
                    _createVNode("div", _hoisted_10, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                        return (_openBlock(), _createBlock("button", {
                          key: page,
                          onClick: ($event: any) => (_ctx.goToPage(page)),
                          class: ["h-2 rounded-full transition-all", 
                _ctx.currentPage === page
                  ? 'bg-red-lp-100 w-7'
                  : 'bg-gray-lp-1400 w-2'
              ]
                        }, null, 10, ["onClick"]))
                      }), 128))
                    ]),
                    (_ctx.currentPage < _ctx.totalPages)
                      ? (_openBlock(), _createBlock("button", {
                          key: 2,
                          class: "focus:outline-none p-1 hover:bg-gray-lp-200 rounded transition-colors",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
                        }, [
                          _createVNode("img", {
                            src: require('@/app/ui/assets/svg/chevron-next.svg'),
                            alt: "Next",
                            class: "h-4 w-4"
                          }, null, 8, ["src"])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_11))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 512)
      ]))
    : _createCommentVNode("", true)
})